var map = {
	"./Subtract.svg": "7da5",
	"./ad.png": "b39b",
	"./ad2.png": "ef23",
	"./appleWallet_btn.svg": "4430",
	"./arrow.svg": "27e4",
	"./back-arrow.svg": "f4de",
	"./banner.jpg": "301c7",
	"./banner.png": "1936",
	"./banner2.jpg": "db49",
	"./bannerImg.png": "8a73",
	"./banner_mobile.jpg": "d390",
	"./banner_test.jpg": "5904",
	"./bg.svg": "2370",
	"./bullet.svg": "8f8f",
	"./card1.jpg": "16e1",
	"./card2.jpg": "0ec4",
	"./card3.jpg": "5392",
	"./card4.jpg": "1b12",
	"./card5.jpg": "4b07",
	"./chop.svg": "66bb",
	"./close.svg": "2930",
	"./couponBanner_1.png": "27d7",
	"./couponBanner_2.png": "c5d4",
	"./couponBanner_3.png": "f547",
	"./email 2.svg": "03c3",
	"./email.svg": "7711",
	"./email3.png": "e7a8",
	"./facebook.svg": "44c6",
	"./giftCard.png": "9d4e",
	"./google.svg": "b5df",
	"./gpay_btn.svg": "144a",
	"./gradient-bottom 1.png": "40d6",
	"./icon-heart.svg": "d2a2",
	"./ig.svg": "0c88",
	"./lang.svg": "c561",
	"./location.svg": "3589",
	"./logo-dummy.png": "e1fb",
	"./logo.svg": "e347",
	"./logo3.png": "bdf3",
	"./logo_b.svg": "e9bd",
	"./logo_partner.jpg": "4dd9",
	"./magnifying.svg": "e024",
	"./mask_group.svg": "0b29",
	"./mask_item.svg": "3b2d",
	"./msVoucher_banner.png": "689b",
	"./next-arrow.svg": "e695",
	"./next.svg": "35fe",
	"./orderBanner.png": "3ff6",
	"./otoLogo.jpg": "0bdc",
	"./panel-b.svg": "8e6d",
	"./panel-l.svg": "c8e8",
	"./panel-r.svg": "e204",
	"./panel-t.svg": "fdcb",
	"./plus-symbol.svg": "2d5b",
	"./point-right.svg": "9e9c",
	"./point.svg": "7834",
	"./pointer.svg": "6f85",
	"./prev.svg": "d5e2",
	"./rabbitBg.svg": "c490",
	"./rabbit_head.svg": "0765",
	"./ribbon.png": "395f",
	"./ribbon.svg": "57fa",
	"./s1.svg": "4d0b",
	"./s2.svg": "7cc7",
	"./s3.svg": "0781",
	"./submit.svg": "9534",
	"./t1.svg": "0ded",
	"./t2.svg": "a7b0",
	"./t3.svg": "1865",
	"./thankBanner.png": "fbc5",
	"./thankListImg.png": "34aa",
	"./thumbnail.png": "4020",
	"./thumbnail2.png": "4cbf",
	"./twitter.png": "9284",
	"./twitter.svg": "1538",
	"./user.svg": "c9d8",
	"./wallet.svg": "b23e",
	"./wechat.png": "37c4",
	"./whatsapp.svg": "e8a9",
	"./wrapper2.svg": "8a92",
	"./youtube.svg": "694f",
	"./zhop_logo.svg": "b9a9",
	"./zhop_logo2.svg": "1cd4",
	"./zhop_logo3.svg": "7ea3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";